import { render, staticRenderFns } from "./bo.vue?vue&type=template&id=29d5b215&scoped=true&"
import script from "./bo.vue?vue&type=script&lang=js&"
export * from "./bo.vue?vue&type=script&lang=js&"
import style0 from "./bo.vue?vue&type=style&index=0&id=29d5b215&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d5b215",
  null
  
)

export default component.exports